import { render, staticRenderFns } from "./confirm-transaction.component.vue?vue&type=template&id=c2434f56"
import script from "./confirm-transaction.component.vue?vue&type=script&lang=js"
export * from "./confirm-transaction.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports